module.exports = __webpack_public_path__ + "static/media/8pic.c3afcc0f.jpg";